export const locale = {
    lang: "es",
    data: {
        PURCHASE: {
            PURCHASE: "Órdenes de Compra",
        },
    },
};
